export const data =[
  {
    "Title": "A-Bomb",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "A-Bomb",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "A-Bomb",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "A-Bomb",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "A-Bomb",
    "Issue #": 9,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "A-Bomb",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Adolescent Radioactive Black Belt Hamsters 3-D",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Parody",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "All New Underground Comics",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "All New Underground Comics",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Amazon Comics",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "American Flyer Funnies",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Welz C/A",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Amputee Love",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Underground",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Amra V2",
    "Issue #": 58,
    "Condition": "NM",
    "Website Notes": "Fanzine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Amra V2",
    "Issue #": 68,
    "Condition": "NM",
    "Website Notes": "Fanzine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Amra V2",
    "Issue #": 69,
    "Condition": "NM",
    "Website Notes": "Fanzine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Amra V2",
    "Issue #": 71,
    "Condition": "NM",
    "Website Notes": "Fanzine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "A+ Plus",
    "Issue #": 3,
    "Condition": "VF+",
    "Website Notes": "1978 Fantasy",
    "Personal Notes (Not on website)": "Megaton",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Are Your Highs  Getting You Down?",
    "Issue #": "NN",
    "Condition": "VF",
    "Website Notes": 1981,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Armageddon",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Art & Beauty",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Artistic Comics",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1985 Crumb",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Artistic Comics",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Golden Gate",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Artistic Comics",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Golden Gate",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Astral Outhouse",
    "Issue #": "nn",
    "Condition": "FN/VF",
    "Website Notes": 1977,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Baby, You're really something",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Bakersfield Kountry Komics",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Cherry Proto",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Balloon Vendor",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 3,
    "": "gilligans"
  },
  {
    "Title": "Barefootz Funnies",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1976,
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Barefootz Funnies",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": 1976,
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Barn of Fear",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1978,
    "Personal Notes (Not on website)": "CAG",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Best Buy Comics",
    "Issue #": "",
    "Condition": "FN",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Best of Wonder Wart-Hog",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "1st Print 1973",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Best of Wonder Wart-Hog",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": ".75 Cover Price",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Best of Wonder Wart-Hog",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Big Ass Comics",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "4th Print Crumb",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 10,
    "": "2 avail"
  },
  {
    "Title": "Big Ass Comics",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": ".75 Cover Price",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Big Ass Comics",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Bijou Funnies",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "2nd Print .50 Cover Price",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Bijou Funnies",
    "Issue #": 3,
    "Condition": "VF+",
    "Website Notes": "2nd Print .50 over Price",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Bijou Funnies",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "2nd Print .50 over Price",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Bijou Funnies",
    "Issue #": 4,
    "Condition": "FN",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Bijou Funnies",
    "Issue #": 5,
    "Condition": "NM-",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Bijou Funnies",
    "Issue #": 6,
    "Condition": "NM",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Bijou Funnies",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "3rd Print Crumb",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Bijou Funnies",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Bizarre Sex",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": ".65 Cvr Price",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Blazing Foxholes",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 15,
    "": "Steve"
  },
  {
    "Title": "Blonde Bondage Palace",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 8,
    "": "steve"
  },
  {
    "Title": "Broken Engagement",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "Heroes"
  },
  {
    "Title": "Brunner's Carnal Delights",
    "Issue #": "NN",
    "Condition": "NM",
    "Website Notes": "Brunner Art",
    "Personal Notes (Not on website)": "Carnal",
    "Cost Basis": 20,
    "": "2025 BCC"
  },
  {
    "Title": "Bum Wad",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": "1st Print 1971",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Captain Guts",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "1969 2nd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Captain Guts",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": 1969,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Captain Guts",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Cartoon History of the Universe",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off",
    "Cost Basis": 3,
    "": "gilligans"
  },
  {
    "Title": "Cartoon History of the Universe",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Cerebus",
    "Issue #": 55,
    "Condition": "VF/NM",
    "Website Notes": "Wolveroach",
    "Personal Notes (Not on website)": "Aardvark",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Cerebus",
    "Issue #": 56,
    "Condition": "VF/NM",
    "Website Notes": "Wolveroach",
    "Personal Notes (Not on website)": "Aardvark",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "CFD Book of Lingerie",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "CFD",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "CFD Book of Lingerie",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "CFD",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Cheech Wizard",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "Scarcer 1987",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 3,
    "": "lehigh"
  },
  {
    "Title": "Cheeta Pop",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Cheeta Pop",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Cherry Collection",
    "Issue #": "Vol 2",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Yetzler",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Cherry Deluxe",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Gaiman Story",
    "Personal Notes (Not on website)": "Yetzler",
    "Cost Basis": 10,
    "": "2 avail"
  },
  {
    "Title": "Cherry Poptart",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": ""
  },
  {
    "Title": "Cherry Poptart",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "Yetzler",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Cherry Poptart",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 20,
    "": "Laurel"
  },
  {
    "Title": "Cherry Poptart",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Yetzler",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Cherry Poptart",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Yetzler",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Cherry Poptart",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Yetzler",
    "Cost Basis": 15,
    "": "Foundations Edge"
  },
  {
    "Title": "Cherry's Jubilee",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "Indy"
  },
  {
    "Title": "Chocolate Alphabet",
    "Issue #": 1978,
    "Condition": "VF/NM",
    "Website Notes": "Harlan Ellison",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Cocaine Comix",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "Dicaprio",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 4,
    "": "lehigh"
  },
  {
    "Title": "Collected Gold Digger TPB",
    "Issue #": 1994,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Antarctic",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Collected Purple Pictography",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Commies From Mars",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 10,
    "": "2025 BCC"
  },
  {
    "Title": "Compleat Fart",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1976,
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Complete Cheech Wizard",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "Bode'",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Conspiracy Capers",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "1969 Williamson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Consumer Comi",
    "Issue #": "",
    "Condition": "VF",
    "Website Notes": 1975,
    "Personal Notes (Not on website)": "Wisc DOJ",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Contessa",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Coochy Cooty",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Countdown: Sex Bombs",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Coven of Angels",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Linsner Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Cover-Up Lowdown",
    "Issue #": "NN",
    "Condition": "NM-",
    "Website Notes": "1st Print Digest",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Crack Whore",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Crow: Wild Justice",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Crypt of Dawn",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "sirius",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Crypt of Dawn",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "sirius",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Crypt of Dawn",
    "Issue #": 6,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "sirius",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Cud",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Fantagraphics",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Dan O'Neil's Comics",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Co & Sons",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Dark Fantasies",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Linsner Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Death Dealer",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Frazetta Cvr",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Death Dealer",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Frazetta Cvr",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Death Rattle",
    "Issue #": "V2#1",
    "Condition": "NM",
    "Website Notes": "Corbin C/A",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 8,
    "": "SDCon 2 avail"
  },
  {
    "Title": "Death Rattle",
    "Issue #": 16,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Death Rattle (1995)",
    "Issue #": "V3#1",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Debbie Does Dallas",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Aircel",
    "Cost Basis": 20,
    "": "BCC 2 avail"
  },
  {
    "Title": "Debbie Does Dallas",
    "Issue #": 18,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Aircel",
    "Cost Basis": 20,
    "": "BCC"
  },
  {
    "Title": "Demented Pervert",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Despair",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Despair",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Deviant Slice",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Deviant Slice",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Dirty Duck Book",
    "Issue #": 1971,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Cocoanut",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Dirty Laundry Comics",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Crumb 1st Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Ditko's Wha..!?",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": "Ditko 1975",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Doll",
    "Issue #": "1-4",
    "Condition": "NM",
    "Website Notes": "Complete Set",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Dopin' Dan",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "1972 1st Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Dr Atomic",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 4,
    "": ""
  },
  {
    "Title": "Dr Atomic",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 4,
    "": ""
  },
  {
    "Title": "Dr Atomic",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Dr Atomic",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "1st Print Scarce",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Dr. Wirtham's Comix & Stories",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": 1976,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Dr. Wirtham's Comix & Stories",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": 1978,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Dr. Wirtham's Comix & Stories",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": 1979,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Drool",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "El Perfecto Comics",
    "Issue #": "",
    "Condition": "FN",
    "Website Notes": "R Crumb",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Emblem",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Emblem",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Emblem",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Emblem",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Emblem",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Enigma!",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": 1976,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Exposed The Erotic Art of Al Rio",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Avatar",
    "Cost Basis": 20,
    "": "steve"
  },
  {
    "Title": "Fantagor",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "1st Print 1972 Corben",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Fat Freddy's Cat",
    "Issue #": 3,
    "Condition": "VF+",
    "Website Notes": "$1.25 Cover Price",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Fat Freddy's Cat",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "$2.95 Cover Price",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Fat Freddy's Cat",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Fat Freddy's Cat",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "$2.95 Cover Price",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Fear and Laughter",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1977,
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Feds 'N' Heads Comics",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "4th Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Feds 'N' Heads Comics",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "4th Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": ""
  },
  {
    "Title": "Feelgood Funnies",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1972 Shelton",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Fever Dreams",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "1st Print Corben",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Fever Dreams",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": ".75 Cover Price",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "50's Blast From the Past Funnies",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Flamed Out Funnies",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "1st Print 1975",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "2 avail"
  },
  {
    "Title": "Flaming Carrot",
    "Issue #": 9,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Renegade",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Fog City Comics",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1977,
    "Personal Notes (Not on website)": "Stampart",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Freak Brothers",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Freak Brothers",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Freak Brothers",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Freak Brothers",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Freak Brothers",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": ".75 Cvr Price",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Freak Brothers",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "1.50 Cvr Price",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Freak Brothers",
    "Issue #": 12,
    "Condition": "FN",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Freak Brothers",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Frollo- Art By Leone Frollo",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Blue Glamour",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Funny Animals",
    "Issue #": "",
    "Condition": "F/VF",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Funnybook",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "1st Cherry",
    "Personal Notes (Not on website)": "AP Co",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Gasp!",
    "Issue #": "NN",
    "Condition": "NM",
    "Website Notes": "Horror",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "BCC 2025"
  },
  {
    "Title": "Geiser's Clowns",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Yahoo",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Geiser's Saloon",
    "Issue #": "NN",
    "Condition": "VF",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Yahoo",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Geiser's Pervertsementels",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Yahoo",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Ghoulash",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Gimme",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Girl Fight Comics",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": 1974,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Good Jive Comix",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Poo Bear",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Googiewaumer Comics",
    "Issue #": "",
    "Condition": "VF",
    "Website Notes": 1969,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Gory Stories Quarterly",
    "Issue #": "21/2",
    "Condition": "VF",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Hafaso",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Greaser",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1971,
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Greaser",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Griffith Observatory",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1979 1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Grim Wit",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Grim Wit",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 2,
    "": "2 avail"
  },
  {
    "Title": "Guano Comix",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Happy Endings Comics",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Hash-Slinger Comix",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": 1978,
    "Personal Notes (Not on website)": "Green River",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Harold Hedd",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Harold Hedd",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "2nd Print 1975",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Harold Hedd Hitler's Cocaine",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Home Grown Funnies",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "Crumb .50 Cvr Price",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Home Grown Funnies",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "4th Print Crmb",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Home Grown Funnies",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "9th Print Crmb",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Honky Tonk",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "1970 Geiser",
    "Personal Notes (Not on website)": "Co & Sons",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Horny Biker Sluts",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": "Hunt Valley"
  },
  {
    "Title": "Horny Biker Sluts",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Horny Biker Sluts",
    "Issue #": 9,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Horny Biker Sluts",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Horny Biker Sluts",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Horny Biker Sluts",
    "Issue #": 12,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Horny Biker Sluts",
    "Issue #": 13,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Horny Toads",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Wood C/A",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Hot Stuff",
    "Issue #": 4,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Hot Stuff",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Hungry Chuck Biscuits",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "1st Print 1971",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Hydrogen Bomb",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1st Print 1970",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Hydrogen Bomb",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "1st Print 1970",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "2 avail"
  },
  {
    "Title": "Illuminatus!",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip off Press",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Incredible Facts O' Life",
    "Issue #": "",
    "Condition": "F/VF",
    "Website Notes": "1972 2nd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Independent Voices",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Linsner Cvr",
    "Personal Notes (Not on website)": "Peregrine",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Inner City Romance",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Inner City Romance",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Jaguar God",
    "Issue #": 0,
    "Condition": "NM",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Jaguar God",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Jaguar God",
    "Issue #": 6,
    "Condition": "NM",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Jaguar God",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Jesus Meets the Armed Services",
    "Issue #": "",
    "Condition": "VF",
    "Website Notes": "4th Print 1970",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Joe Chiodo Drawings and Paintings",
    "Issue #": "TPB",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Hermes",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Junkwaffel",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "1st Print Bode'",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Junkwaffel",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "1st Print Bode'",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Junkwaffel",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "1st Print Bode'",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 3,
    "": ""
  },
  {
    "Title": "Junkwaffel",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "1st Print Bode'",
    "Personal Notes (Not on website)": "Print Mint 2 avail",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Junkwaffel",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "1st Print Bode'",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 3,
    "": ""
  },
  {
    "Title": "Junkwaffel",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "1st Print Bode'",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Karate Girl",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Karate Girl",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Karate Girl Special",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Karate Girl Tengu Wars",
    "Issue #": "1-3",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "KillJoy",
    "Issue #": 0,
    "Condition": "NM",
    "Website Notes": "Dragon Con Ed",
    "Personal Notes (Not on website)": "London Night",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Kingdom of Heaven is Within You Comix",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "Scarce 1969",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Kinky Hook",
    "Issue #": "",
    "Condition": "VF",
    "Website Notes": "Stanton",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "KommaKazi Komix",
    "Issue #": "NN",
    "Condition": "FN",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Kukawy Comics",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1969,
    "Personal Notes (Not on website)": "7 Seal",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "L.A.Comics",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Lady in Charge",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "Heroes"
  },
  {
    "Title": "Last Supplement to the Whole Earth Catalog",
    "Issue #": 1971,
    "Condition": "VG/F",
    "Website Notes": "Crumb Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Lean Years",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "1974 Pound",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Leather & Lace",
    "Issue #": "TPB",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Hunt Valley"
  },
  {
    "Title": "Lipstick",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Little Green Dinosaur",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Little Green Dinosaur",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Magical Nymphini",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Man",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "2nd Print Bode'",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Mara",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Mara Paper Doll Book",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Me and Her",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Mean Bitch Thrills",
    "Issue #": "",
    "Condition": "VF",
    "Website Notes": 1971,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Meet Miss Pepper",
    "Issue #": 5,
    "Condition": "GD",
    "Website Notes": "Rare",
    "Personal Notes (Not on website)": "St John",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Merton of the Movement",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Cocoanut",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Merton of the Movement",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Cocoanut",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Miami Mice Comic",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1985,
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Milk & Cheese",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Slave Labor",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Mom's Homemade Comics",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "3rd Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Moondog",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": 1971,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Mother's Oats Comix",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Motor City Comics",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "2nd Print 1969",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Motor City Comics",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "4th Print 1970",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Motor City Comics",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "3rd Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Motor City Comics",
    "Issue #": 2,
    "Condition": "GD",
    "Website Notes": "3rd Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Mr. Natural",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1st Print 1970",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Mr. Natural",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "1st Print 1970",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Mr. Natural",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": ".50 Cvr Price Crumb",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Mr. Natural",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "1st Print 1971",
    "Personal Notes (Not on website)": "SF Comic Book Co",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Mr. Natural",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": ".50 Cvr Price Crumb",
    "Personal Notes (Not on website)": "SF Comic Book Co 2 avail",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Mr. Natural",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "3rd Print",
    "Personal Notes (Not on website)": "SF Comic Book Co 2 avail",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Mutants of the Metropolis",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "LA Comic Book Co.",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Myron Moose Funnies",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Near Myths (Trina Robbins')",
    "Issue #": "",
    "Condition": "VF+",
    "Website Notes": 1980,
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "New Horizons",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Shanda",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "New Love",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Love and Rockets",
    "Personal Notes (Not on website)": "Fantagraphic",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "No Ducks!",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "No Such Thing as Monsters",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Chorus Comics",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Ocelot",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "O.K. Comics",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 0,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 3,
    "": "2 avail"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 3,
    "": "2 avail"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 6,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "2 avail"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "2 avail"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "2 avail"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 14,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 16,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 17,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 18,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Omaha The Cat Dancer",
    "Issue #": 20,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "One-Fisted Tales",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "Cherry C/S",
    "Personal Notes (Not on website)": "Slave Labor",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "One-Fisted Tales",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Slave Labor",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "One-Fisted Tales",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Slave Labor",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Outer Space Babes",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Silhouette",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Overland Vegetable Stagecoach Presents Meef",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Overland Vegetable Stagecoach Presents Balloon Vendor",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": 1971,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Pain",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1977 Geiser",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Penthouse Comix",
    "Issue #": 26,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Penthouse",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Penthouse Comix",
    "Issue #": 28,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Penthouse",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Penthouse Comix",
    "Issue #": 29,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Penthouse",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Penthouse Comix",
    "Issue #": 30,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Penthouse",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Penthouse Comix",
    "Issue #": 33,
    "Condition": "NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "Penthouse",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "People's Comics",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "1st Print Death of Fritz the Cat",
    "Personal Notes (Not on website)": "Golden Gate",
    "Cost Basis": 5,
    "": "2 avail"
  },
  {
    "Title": "Peter Kock",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Pink Floyd's The Wall",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Theater Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Power Pak Comics",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Crumb",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Pudge Girl Blimp",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Star Reach",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Pure Joy Comix",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Poo Bear",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Quack!",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "Brunner C/A",
    "Personal Notes (Not on website)": "Star Reach",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Quack!",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Star Reach",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Rainbow Funnies",
    "Issue #": "1&2",
    "Condition": "VF/NM",
    "Website Notes": 1978,
    "Personal Notes (Not on website)": "Three Rivers",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Ramba",
    "Issue #": "1-14",
    "Condition": "NM",
    "Website Notes": "Complete Set",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 150,
    "": "steve"
  },
  {
    "Title": "Ramba",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Ramba",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "R. Crumb's Comics and Stories",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1969,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Real Pulp Comics",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1971 Zippy Prototype",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Real Smut!",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Drek",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Real Smut!",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "Drek",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Real Smut!",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "Drek",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Revolver",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "Ditko C/A",
    "Personal Notes (Not on website)": "Renegade",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Rip in Time",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "Fantagor",
    "Cost Basis": 15,
    "": "2025 BCC"
  },
  {
    "Title": "Rip in Time",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "Fantagor",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Rip in Time",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "Fantagor",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Rip Off Comix",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Rip Off Comix",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Rip Off Comix",
    "Issue #": 5,
    "Condition": "FN+",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Rip Off Comix",
    "Issue #": 9,
    "Condition": "NM",
    "Website Notes": "$1.50 Cover Price",
    "Personal Notes (Not on website)": "Rip Off Comix",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Rip Off Comix",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Rip Off Comix",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Robot Comics",
    "Issue #": 0,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Renegade",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Rowlf",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "1st Print Corben",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Roxy Funnies",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "1972 Lynch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Roxy Funnies",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "1972 Lynch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sally Forth",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "Wood",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 20,
    "": "BCC 2025"
  },
  {
    "Title": "San Francisco Comic Book",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": 1970,
    "Personal Notes (Not on website)": "SF Comic Book Co",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "San Francisco Comic Book",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": 1970,
    "Personal Notes (Not on website)": "SF Comic Book Co",
    "Cost Basis": 3,
    "": ""
  },
  {
    "Title": "San Francisco Comic Book",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "Crumb 1st Print",
    "Personal Notes (Not on website)": "SF Comic Book Co",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "San Francisco Comic Book",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "Crumb 1st Print",
    "Personal Notes (Not on website)": "SF Comic Book Co",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "San Francisco Comic Book",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "SF Comic Book Co",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Sapphire",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Aircel",
    "Cost Basis": 10,
    "": "2025 BCC"
  },
  {
    "Title": "Satanica",
    "Issue #": 0,
    "Condition": "NM",
    "Website Notes": "Frazetta Cvr",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Savage Humor",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Savage Humor",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Schizophrenia",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "1st Print Bode'",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Screw Comics",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Hitler C/S",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Self Loathing Comics",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Fantagraphic",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Self Loathing Comics",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "2nd print",
    "Personal Notes (Not on website)": "Fantagraphic",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sexecutioner",
    "Issue #": "Vol2#3",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Sexy Tales to Give you the Creeps",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Shi",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Tucci 1st Print",
    "Personal Notes (Not on website)": "Crusade",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Shi",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Tucci 1st Print",
    "Personal Notes (Not on website)": "Crusade",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Shi",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "Tucci 1st Print",
    "Personal Notes (Not on website)": "Crusade",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Short Order Comix",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "1972 Griffith",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "two avail"
  },
  {
    "Title": "Show & Tell Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Silky Whip",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Sixty Nine",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Skull Comics",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": ".50 Cover Price",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Skull Comics",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "1972 6th Print",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Skull Comics",
    "Issue #": 6,
    "Condition": "FN+",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Sleazy Scandals of the Silver Screen",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "3rd Print 1989",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "Slow Death",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Slow Death",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "1st Print Corben",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Slow Death",
    "Issue #": 5,
    "Condition": "VF+",
    "Website Notes": "1st Print Corben",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Slow Death",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 3,
    "": "gilligans"
  },
  {
    "Title": "Slow Death",
    "Issue #": 8,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Smile",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "1st Print 1970",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Smile",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "1st Print 1970",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Snoid Comics",
    "Issue #": "",
    "Condition": "FN+",
    "Website Notes": "Crumb 1st Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Soft Core",
    "Issue #": "",
    "Condition": "F/VF",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Son of Mutant World",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "Fantagraphics",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Son of Mutant World",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Corben",
    "Personal Notes (Not on website)": "Fantagraphics",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Son of Mutant World",
    "Issue #": "1-4",
    "Condition": "NM",
    "Website Notes": "All signed by Corben",
    "Personal Notes (Not on website)": "Fantagraphics",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Space Dog",
    "Issue #": 1,
    "Condition": "F+",
    "Website Notes": 1978,
    "Personal Notes (Not on website)": "Greenwood",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Spank the Monkey",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Arrow",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Spasm!",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "1973 Jeff Jones",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Spicy Adult Stories",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Aircel",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Spicy Tales",
    "Issue #": 9,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Eternity",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Stacia Stories",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Strips",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 5,
    "": "Hunt Valley"
  },
  {
    "Title": "Submissive Suzanne",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Super Taboo",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Tales From the Ozone",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tales of the Armorkins",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1971,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tales of the Armorkins",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "2nd Print 1971",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Tales of Toad",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "1973 1st Zippy!",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tales of Toad",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "1973 2nd Zippy!",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tales Too Terrible To Tell",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "NEC",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tales Too Terrible To Tell",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "NEC",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tales Too Terrible To Tell",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "NEC",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tales Too Terrible To Tell",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "NEC",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Teen-Age Horizons of Shangrila",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "1972 4th Print",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Teen-Age Horizons of Shangrila",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "That Chemical Reflex",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Visual Anarchy",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Time Traveler AI",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "CPM Manga",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Tits & Clits Comix",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "1st Print 1972",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tits & Clits Comix",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Tommi Gunn",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "London Knight",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Tommi Gunn",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "London Knight",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Tooney Loons",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1971,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Tor Love Betty",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Eros",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Tortoise and the hare",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": 1971,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Truckin'",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Truckin'",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "True Glitz",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Tumbling Boxes",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Turned on Cuties",
    "Issue #": "",
    "Condition": "F/VF",
    "Website Notes": "1972 Crumb",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Two Fools",
    "Issue #": "NN",
    "Condition": "VF/NM",
    "Website Notes": 1977,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 1,
    "": ""
  },
  {
    "Title": "2 Hot Girls on a Hot Summer Night",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "Uneeda Comix",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 3,
    "": "2 avail"
  },
  {
    "Title": "Uneeda Comix",
    "Issue #": "",
    "Condition": "GD",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Velvet Touch",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus Comics",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Velvet Touch",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Venus Comics",
    "Cost Basis": 5,
    "": "BCC 2024"
  },
  {
    "Title": "Verotika",
    "Issue #": 13,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Verotika",
    "Issue #": 14,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Verotika",
    "Issue #": 15,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Verotik",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Vic and Blood",
    "Issue #": "1-2",
    "Condition": "NM",
    "Website Notes": "Corben/Ellison",
    "Personal Notes (Not on website)": "Mad Dog Graphics",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "White Lunch Comix",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1972,
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Whoa, Nellie!",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Love and Rockets",
    "Personal Notes (Not on website)": "Fantagraphics",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Wimmen's Comics",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": 1973,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Wimmen's Comics",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": 1974,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Wimmen's Comics",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Wimmen's Comics",
    "Issue #": 8,
    "Condition": "VF",
    "Website Notes": 1982,
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Wimmen's Comix Presents Little Girls",
    "Issue #": 15,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Wonder Wart-Hog Hog of Steel",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Wonder Wart-Hog Hog of Steel",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Wonder Wart-Hog , Best of",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Rip Off Press",
    "Cost Basis": 3,
    "": "gilligans"
  },
  {
    "Title": "Woron's World",
    "Issue #": "1B",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Illustration",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Woron's World",
    "Issue #": "2B",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Illustration",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "Woron's World",
    "Issue #": "3B",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Illustration",
    "Cost Basis": 5,
    "": "steve"
  },
  {
    "Title": "XXXenophile",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Palliard",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "XXXenophile",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Palliard",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "XXXenophile Collection",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "TPB",
    "Personal Notes (Not on website)": "XXXenophile",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "XXX Women",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "EROS",
    "Cost Basis": 10,
    "": "steve"
  },
  {
    "Title": "XYZ Comics",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Crumb .75 Cvr Price",
    "Personal Notes (Not on website)": "Kitchen Sink",
    "Cost Basis": 5,
    "": "20th Century"
  },
  {
    "Title": "Yellow Dog Comics",
    "Issue #": 13,
    "Condition": "VG/F",
    "Website Notes": "1st Print Crumb",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Yellow Dog Comics",
    "Issue #": 18,
    "Condition": "VG+",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Yellow Dog Comics",
    "Issue #": 20,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Yellow Dog Comics",
    "Issue #": 23,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Yellow Dog Comics",
    "Issue #": 24,
    "Condition": "FN",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Yellow Dog Comics",
    "Issue #": 25,
    "Condition": "FN",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Yer Basic Comix",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Young Lust",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Young Lust",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Young Lust",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Print Mint",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Young Lust",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Last Gasp",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Your Hytone Comix",
    "Issue #": "",
    "Condition": "F+",
    "Website Notes": "Crumb 1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Your Hytone Comix",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "Crumb .75 vr Price",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Your Hytone Comix",
    "Issue #": "",
    "Condition": "VG",
    "Website Notes": "Crumb 5th Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Zam Zap Jam",
    "Issue #": "",
    "Condition": "FN",
    "Website Notes": "Shelton Digest Size",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 0,
    "Condition": "VG/F",
    "Website Notes": "4th Print Crumb",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 4,
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "2nd Print Crumb",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 25,
    "": "2 avail"
  },
  {
    "Title": "Zap Comix",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "3rd Print Crumb",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "$2.50 Cover Price",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "3rd Print 1975",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "4th Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "$2.50 Cover Price",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 6,
    "Condition": "FN+",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Zap Comix",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "Apex",
    "Cost Basis": 2,
    "": ""
  }
]
;